// extracted by mini-css-extract-plugin
export default {"min_max_container":"MinMaxPrice_min_max_container__apDuk"};